import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useParams, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData, SyncData, FinishData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save'; // Import the Save icon
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForward from '@mui/icons-material/ArrowForward';
import * as XLSX from 'xlsx';
import Select from 'react-select';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PrintIcon from '@mui/icons-material/Print';
import EstimatePrint from '../SaleOrder/Estimate';
import WrongLocationIcon from '@mui/icons-material/WrongLocation';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import ViewListIcon from '@mui/icons-material/ViewList';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { faSlash } from '@fortawesome/free-solid-svg-icons';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import {
    getModalWrapperStyles,
    getModalContentStyles,
    getButtonContainerStyles,
    getButtonStyles,
    getModalTitleStyles,
    getTableContainerStyles,
    getTableStyles,
    getTableHeadStyles,
    getTableHeaderCellStyles,
    getTableRowStyles,
    getTableCellStyles,
    getEmptyStateCellStyles,
    shouldHighlightRow,
    formatDecimal,
} from './modalStyles';

//import RouteTemp from "./../../pages/RouteTemp";


function TriporderedIndexs() {
    const { id } = useParams(); // trip id 
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const history = useHistory();
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
    const [orderdate, setOrderdate] = useState("");
    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    // const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [formData, setFormData] = useState();
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);


    const [orderDate, setOrderDate] = useState("");
    const [Route, setRoute] = useState("");
    const [routeId, setrouteId] = useState("");

    useEffect(() => {
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchtableData();


    }, []); // run once on mount


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const fetchtableData = async () => {
        try {
            setLoading(true); // start loader before fetch

            const response = await fetchData('TripApi', `/${companyId}/${id}`, token);

            if (response?.responseCode === '1111' && Array.isArray(response.response_data) && response.response_data.length > 0) {
                setData(response.response_data);

                const { tripDate, route, routeID } = response.response_data[0]; // safer destructuring
                setOrderDate(tripDate);
                setRoute(route);
                setrouteId(routeID);

                console.log("Fetched Data:", response.response_data);
            } else {
                console.warn("Unexpected response:", response);
                setData([]); // in case API returns empty data
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);

            if (error?.response?.status === 401) {
                logout();
            }
        } finally {
            setLoading(false); // stop loader after fetch
        }
    };


    //for finding the template with item details (category and weightage)
    const [OrderSheetdata, setOrderSheetData] = useState([]);

    useEffect(() => {
        fetchOrderSheetData();
    }, []);

    const fetchOrderSheetData = async () => {
        try {
            // Correcting the URL formation
            const response = await fetchData('OrderSheetAPI', `/${companyId}`, token);

            if (response.responseCode === '1111') {
                setOrderSheetData(response.response_data);
                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };



    const handleDelete = async () => {
        try {
            await FinishData('TripApi', `${deleteItemId}`, token);

            setDeleteItemId(null);
            setConfirmDialogOpen(false);
            // history.push('/Home');
            //window.location.reload();
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };


    const [showModal, setShowModal] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

    const opendatamodal = () => {
        handleHistoryClick(id);

        setShowModal(true);
    };


    const handleHistoryClick = async (id) => {
        try {
            const response = await fetchData('CustomerDespatchReport', `/${companyId}/${id}`, token);
            if (response.responseCode === '1111') {
                setFilteredData(response.response_data);
                setShowModal(true);
                // console.log('Modal state set to true:', showModal);
            }
            else {
                console.error('Invalid response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };


    const closeModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };

    const openConfirmDialog = (tripId) => {
        setDeleteItemId(tripId);
        setConfirmDialogOpen(true);
        //window.location.reload();
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const handleSaleOrderPrint = async (SaleOrderid) => {
        try {
            // Fetch data
            const response = await fetchData('SaleOrderApi', `/SaleorderPrint/${SaleOrderid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            // Render EstimatePrint component inside iframe
            ReactDOM.render(
                <EstimatePrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();


            try {
                await SyncData('SaleOrderApi', `${SaleOrderid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };
    const tripid = id;

    // sort order list

    const [routeshowmodel, setrouteShowModal] = useState(false);
    const [routeFilteredData, setRouteFilteredData] = useState([]);


    const openroutedatamodal = async () => {
        console.log('Opening route data modal');
        await handleroutecloseClick(id);
        setrouteShowModal(true);
    };

    const handleroutecloseClick = async (id) => {
        console.log('Fetching route data for:', id);
        try {
            const response = await fetchData('AddOrderAPI', `/${companyId}/${id}`, token);
            if (response.responseCode === '1111') {
                setRouteFilteredData(response.response_data);
                setrouteShowModal(true);
            } else {
                console.error('Invalid response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeRouteModal = () => {
        console.log('Closing modal');
        setrouteShowModal(false);
    };

    // Additional order summary
    const [addshowmodel, setaddShowModal] = useState(false);
    const [addFilteredData, setaddFilteredData] = useState([]);


    const openAdddatamodal = async () => {
        console.log('Opening add data modal');
        await handleAdditionalOrder(id);
        setaddShowModal(true);
    };

    const handleAdditionalOrder = async (id) => {
        console.log('Fetching addorder data for:', id);
        try {
            const response = await fetchData('AdditonalReportAPi', `/${companyId}/${id}`, token);
            if (response.responseCode === '1111') {
                setaddFilteredData(response.response_data);
                setaddShowModal(true);
            } else {
                console.error('Invalid response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeaddModal = () => {
        console.log('Closing modal');
        setaddShowModal(false);
    };

    // extra loading
    const [exshowmodel, setexShowModal] = useState(false);
    const [exFilteredData, setexFilteredData] = useState([]);


    const openExdatamodal = async () => {
        console.log('Opening add data modal');
        await handleExtraLoading(id);
        setexShowModal(true);
    };

    const handleExtraLoading = async (id) => {
        console.log('Fetching addorder data for:', id);
        try {
            const response = await fetchData('ExtraLoadingAPI', `/${companyId}/${id}`, token);
            if (response.responseCode === '1111') {
                setexFilteredData(response.response_data);
                setexShowModal(true);
            } else {
                console.error('Invalid response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeexModal = () => {
        console.log('Closing modal');
        setexShowModal(false);
    };

   // // Print for Actual Order
    const handleACtualPrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Actual Order Summary</title>');
        printWindow.document.write('<style>');
        printWindow.document.write('@page { size: A4 portrait; margin: 5mm; }'); // A5 Page Format
        printWindow.document.write('body { font-family: Arial, sans-serif; zoom: 80%; }');
        printWindow.document.write('h3 { font-family: "Times New Roman", Times, serif; font-size: 18px; text-align: center; margin-bottom: 10px; }');
        printWindow.document.write('table { border-collapse: collapse; width: 100%; margin-top: 10px; table-layout: fixed; }');
        printWindow.document.write('th, td { border: 1px solid #ddd; padding: 3px; font-size: 12px; word-wrap: break-word; text-align: center; }');
        printWindow.document.write('th { background-color: #f2f2f2; text-align: center; }');

        // Set column widths for better alignment
        printWindow.document.write('th:nth-child(1), td:nth-child(1) { width: 3%; }');  // Sl.No
        printWindow.document.write('th:nth-child(2), td:nth-child(2) { width: 5%; }');  // Extra Column
        printWindow.document.write('th:nth-child(3), td:nth-child(3) { width: 10%; }'); // Customer Name
        printWindow.document.write('th:nth-child(4), td:nth-child(4) { width: 10%; }'); // Product Category
        printWindow.document.write('th:nth-child(5), td:nth-child(5) { width: 6%; }');  // Code
        printWindow.document.write('th:nth-child(6), td:nth-child(6) { width: 12%; }'); // Item
        printWindow.document.write('th:nth-child(7), td:nth-child(7) { width: 6%; }');  // UOM
        printWindow.document.write('th:nth-child(8), td:nth-child(8) { width: 6%; }');  // Quantity
        printWindow.document.write('th:nth-child(9), td:nth-child(9) { width: 6%; }');  // Bundle
        printWindow.document.write('th:nth-child(10), td:nth-child(10) { width: 7%; }'); // Pieces
        printWindow.document.write('th:nth-child(11), td:nth-child(11) { width: 7%; }'); // Total Qty
        printWindow.document.write('th:nth-child(12), td:nth-child(12) { width: 8%; }'); // Rate per Kg
        printWindow.document.write('th:nth-child(13), td:nth-child(13) { width: 8%; }'); // Taxable Amt
        printWindow.document.write('th:nth-child(14), td:nth-child(14) { width: 8%; }'); // GST Amt
        printWindow.document.write('th:nth-child(15), td:nth-child(15) { width: 10%; }'); // Total Amt
        printWindow.document.write('th:nth-child(16), td:nth-child(16) { width: 10%; }'); // Sale Remarks

        printWindow.document.write('</style></head><body>');
        printWindow.document.write('<h3>Actual Order Summary</h3>');

        // First Row for Route, Order Taken By, and Order Date
        const firstRowData = filteredData[0];
        if (firstRowData) {
            printWindow.document.write('<div style="margin-bottom: 10px;">');
            printWindow.document.write(`<p style="font-size: 12px;"><strong>Route:</strong> ${firstRowData.routeName}</p>`);
            printWindow.document.write(`<p style="font-size: 12px;"><strong>Order Taken by:</strong> ${firstRowData.orderTakenby || ''}</p>`);
            printWindow.document.write(`<p style="font-size: 12px;"><strong>Order Date:</strong> ${firstRowData.orderDate ? new Date(firstRowData.orderDate).toLocaleDateString('en-GB') : ''}</p>`);
            printWindow.document.write('</div>');
        }

        // Start Table
        printWindow.document.write('<table>');
        printWindow.document.write('<thead>');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th>Sl.No</th>');
        printWindow.document.write('<th></th>');
        printWindow.document.write('<th>Customer Name</th>');
        printWindow.document.write('<th>Product Category</th>');
        printWindow.document.write('<th>Code</th>');
        printWindow.document.write('<th>Item</th>');
        printWindow.document.write('<th>UOM</th>');
        printWindow.document.write('<th>Quantity</th>');
        printWindow.document.write('<th>Bundle</th>');
        printWindow.document.write('<th>Pieces</th>');
        printWindow.document.write('<th>Total Qty</th>');
        printWindow.document.write('<th>Rate/Kg</th>');
        printWindow.document.write('<th>Taxable Amt</th>');
        printWindow.document.write('<th>GST Amt</th>');
        printWindow.document.write('<th>Total Amt</th>');
        printWindow.document.write('<th>Sale Remarks</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        filteredData.forEach((rowData, index) => {
            const showCustomerName = index === 0 || rowData.CustomerName !== filteredData[index - 1].CustomerName;
            const showProductCategory = index === 0 || rowData.productCategory !== filteredData[index - 1].productCategory;
            const showRemarks = index === 0 || rowData.Remarks !== filteredData[index - 1].Remarks;
            const isTotalRow = rowData.total; // Check if it's a Total row

            printWindow.document.write(`<tr ${isTotalRow ? 'style="font-weight: bold;"' : ''}>`); // Apply bold style if it's a total row
            printWindow.document.write(`<td>${index + 1}</td>`);
            printWindow.document.write(`<td>${isTotalRow ? `<b>${rowData.total}</b>` : ''}</td>`); // Bold Total
            printWindow.document.write(`<td>${showCustomerName ? rowData.CustomerName : ''}</td>`);
            printWindow.document.write(`<td>${showProductCategory ? rowData.productCategory : ''}</td>`);
            printWindow.document.write(`<td>${rowData.itemCode ? rowData.itemCode : ''}</td>`);
            printWindow.document.write(`<td>${rowData.item ? rowData.item : ''}</td>`);
            printWindow.document.write(`<td>${rowData.kilogram ? rowData.kilogram : ''}</td>`);
            printWindow.document.write(`<td>${rowData.quantity ? rowData.quantity : ''}</td>`);
            printWindow.document.write(`<td>${rowData.bundle ? rowData.bundle : '0'}</td>`);
            printWindow.document.write(`<td>${rowData.pieces ? rowData.pieces : '0'}</td>`);
            printWindow.document.write(`<td>${rowData.totalquantity ? rowData.totalquantity : ''}</td>`);
            printWindow.document.write(`<td>${rowData.RatePerKg ? rowData.RatePerKg : ''}</td>`);
            printWindow.document.write(`<td>${rowData.taxableamount ? rowData.taxableamount.toFixed(2) : '0.00'}</td>`);
            printWindow.document.write(`<td>${rowData.gstamount ? rowData.gstamount.toFixed(2) : '0.00'}</td>`);
            printWindow.document.write(`<td>${rowData.totalAmount ? rowData.totalAmount : ''}</td>`);
            printWindow.document.write(`<td>${showRemarks ? rowData.Remarks : ''}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    }; 



    const handleAddPrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Additional Order Summary</title>');
        printWindow.document.write('<style>');
        printWindow.document.write('@page { size: A4 portrait; margin: 5mm; }');
        printWindow.document.write('body { font-family: Arial, sans-serif; zoom: 80%; margin: 0; padding: 0; }');
        printWindow.document.write('h3 { font-family: "Times New Roman", Times, serif; font-size: 18px; text-align: center; margin-bottom: 10px; }');
        printWindow.document.write('table { border-collapse: collapse; width: 100%; margin-top: 10px; table-layout: fixed; }');
        printWindow.document.write('th, td { border: 1px solid #ddd; padding: 3px; font-size: 12px; word-wrap: break-word; text-align: center; }');
        printWindow.document.write('th { background-color: #f2f2f2; text-align: center; }');
        printWindow.document.write('</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h3>Additional Order Summary</h3>');

        // First Row for Route, Order Taken By, and Order Date
        const firstRowData = addFilteredData[0];
        if (firstRowData) {
            printWindow.document.write(`
                <div style="margin-bottom: 10px;">
                    <p style="font-size: 14px; font-weight: bold;">Route: ${firstRowData.routeName || '-'}</p>
                    <p style="font-size: 14px;">Order Taken by: ${firstRowData.orderTakenby || '-'}</p>
                    <p style="font-size: 14px;">Order Date: ${firstRowData.orderDate ? new Date(firstRowData.orderDate).toLocaleDateString('en-GB') : '-'}</p>
                </div>
            `);
        }

        // Start Table
        printWindow.document.write(`
            <table>
                <thead>
                    <tr>
                        <th>Sl.No</th>
                        <th>Customer Name</th>
                        <th>Product Category</th>
                        <th>Code</th>
                        <th>Item</th>
                        <th>UOM (Kgs)</th>
                        <th>Quantity (no. pieces)</th>
                        <th>Bundle</th>
                        <th>Pieces</th>
                        <th>Total Qty (kgs)</th>
                        <th>Rate (per Kg)</th>
                        <th>Taxable Amt</th>
                        <th>Total GST Amt</th>
                        <th>Total Amt</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
        `);

        let previousCustomer = null;

        addFilteredData.forEach((rowData, index) => {
            const customerName = rowData.CustomerName !== previousCustomer ? rowData.CustomerName || '-' : '';
            previousCustomer = rowData.CustomerName;

            printWindow.document.write(`
                <tr>
                    <td style="text-align: center;">${index + 1}</td>
                    <td>${customerName}</td>
                    <td>${rowData.productCategory || '-'}</td>
                    <td>${rowData.itemCode || '-'}</td>
                    <td>${rowData.item || '-'}</td>
                    <td style="color: coral;">${rowData.kilogram || '-'}</td>
                    <td style="text-align: center;">${rowData.quantity || '-'}</td>
                    <td style="text-align: center;">${rowData.bundle || '0'}</td>
                    <td style="text-align: center;">${rowData.pieces || '0'}</td>
                    <td style="text-align: right;">${rowData.totalquantity || '-'}</td>
                    <td style="text-align: right;">${rowData.RatePerKg || '-'}</td>
                    <td style="text-align: right;">${rowData.taxableamount || '-'}</td>
                    <td style="text-align: right;">${(rowData.gstamount || 0).toFixed(2)}</td>
                    <td style="text-align: right;">${(rowData.totalAmount || 0).toFixed(2)}</td>
                    <td style="text-align: right;">${rowData.SaleRemarks || '-'}</td>
                </tr>
            `);
        });

        // Close Table and Body
        printWindow.document.write(`</tbody></table></body></html>`);

        // Print and Close
        printWindow.document.close();
        printWindow.print();
    };


    // print for extra loading
    const handleExtraPrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>ExtraLoading Summary</title>');
        printWindow.document.write('<style>');
        printWindow.document.write('@page { size: A4 portrait; margin: 5mm; }');
        printWindow.document.write('body { font-family: Arial, sans-serif; zoom: 80%; margin: 0; padding: 0; }');
        printWindow.document.write('h3 { font-family: "Times New Roman", Times, serif; font-size: 18px; text-align: center; margin-bottom: 10px; }');
        printWindow.document.write('table { border-collapse: collapse; width: 100%; margin-top: 10px; table-layout: fixed; }');
        printWindow.document.write('th, td { border: 1px solid #ddd; padding: 3px; font-size: 12px; word-wrap: break-word; text-align: center; }');
        printWindow.document.write('th { background-color: #f2f2f2; text-align: center; }');
        printWindow.document.write('</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h3>ExtraLoading Summary</h3>');

        // First Row for Route, Order Taken By, and Order Date
        const firstRowData = exFilteredData[0];
        if (firstRowData) {
            printWindow.document.write(`
                <div style="margin-bottom: 10px;">
                    <p style="font-size: 14px; font-weight: bold;">Route: ${firstRowData.routeName || '-'}</p>
                    <p style="font-size: 14px;">Order Taken by: ${firstRowData.orderTakenby || '-'}</p>
                    <p style="font-size: 14px;">Order Date: ${firstRowData.orderDate ? new Date(firstRowData.orderDate).toLocaleDateString('en-GB') : '-'}</p>
                </div>
            `);
        }

        // Start Table
        printWindow.document.write(`
            <table>
                <thead>
                    <tr>
                        <th>Sl.No</th>
                        <th>Product Category</th>
                        <th>Code</th>
                        <th>Item</th>
                        <th>UOM (Kgs)</th>
                        <th>Quantity (no. pieces)</th>
                        <th>Bundle</th>
                        <th>Pieces</th>
                        <th>Total Qty (kgs)</th>
                        <th>Rate (per Kg)</th>
                        <th>Taxable Amt</th>
                        <th>Total GST Amt</th>
                        <th>Total Amt</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
        `);

        let previousRemarks = null;
        let previousproductCategory = null;

        exFilteredData.forEach((rowData, index) => {
            const remark = rowData.Remarks !== previousRemarks ? rowData.Remarks || '-' : '';
            previousRemarks = rowData.Remarks;

            const productCategory = rowData.productCategory !== previousproductCategory ? rowData.productCategory || '-' : '';
            previousproductCategory = rowData.productCategory;

            printWindow.document.write(`
                <tr>
                    <td style="text-align: center;">${index + 1}</td>
                    <td>${productCategory}</td>
                    <td>${rowData.itemCode || '-'}</td>
                    <td>${rowData.item || '-'}</td>
                    <td style="color: coral;">${rowData.kilogram || '-'}</td>
                    <td style="text-align: center;">${rowData.quantity || '-'}</td>
                    <td style="text-align: center;">${rowData.bundle || '0'}</td>
                    <td style="text-align: center;">${rowData.pieces || '0'}</td>
                    <td style="text-align: right;">${rowData.totalquantity || '-'}</td>
                    <td style="text-align: right;">${rowData.RatePerKg || '-'}</td>
                    <td style="text-align: right;">${rowData.taxableamount || '-'}</td>
                    <td style="text-align: right;">${(rowData.gstamount || 0).toFixed(2)}</td>
                    <td style="text-align: right;">${(rowData.totalAmount || 0).toFixed(2)}</td>
                    <td style="text-align: right;">${remark}</td>
                </tr>
            `);
        });

        // Close Table and Body
        printWindow.document.write(`</tbody></table></body></html>`);

        // Print and Close
        printWindow.document.close();
        printWindow.print();
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>SortOrder List</title>');
        printWindow.document.write('<style>');
        printWindow.document.write(`
      @page {
        size: A4 portrait;
        margin: 8mm;
      }
      body {
        font-family: Arial, sans-serif;
        zoom: 85%;
        color: #000;
      }
      h3 {
        font-family: "Times New Roman", Times, serif;
        font-size: 18px;
        text-align: center;
        margin-bottom: 10px;
        text-transform: uppercase;
      }
      p {
        margin: 2px 0;
        font-size: 12px;
      }
      table {
        border-collapse: collapse;
        width: 100%;
        margin-top: 10px;
        table-layout: fixed;
      }
      thead {
        display: table-header-group; /* Repeat header on every page */
      }
      th, td {
        border: 1px solid #444;
        padding: 4px 3px;
        font-size: 12px;
        word-wrap: break-word;
        text-align: center;
      }
      th {
        background-color: #f0f0f0;
        font-weight: bold;
      }
      tbody tr:nth-child(even) {
        background-color: #fafafa; /* Zebra striping */
      }

      /* Corrected Column Widths */
      th:nth-child(1), td:nth-child(1) { width: 3%; }   /* Sl.No */
      th:nth-child(2), td:nth-child(2) { width: 8%; }   /* Order Type */
      th:nth-child(3), td:nth-child(3) { width: 10%; }  /* Product Category */
      th:nth-child(4), td:nth-child(4) { width: 10%; }  /* Category */
      th:nth-child(5), td:nth-child(5) { width: 6%; }   /* Code */
      th:nth-child(6), td:nth-child(6) { width: 13%; }  /* Item */
      th:nth-child(7), td:nth-child(7) { width: 5%; }   /* UOM */
      th:nth-child(8), td:nth-child(8) { width: 6%; }   /* Quantity */
      th:nth-child(9), td:nth-child(9) { width: 5%; }   /* Bundle */
      th:nth-child(10), td:nth-child(10) { width: 5%; } /* Pieces */
      th:nth-child(11), td:nth-child(11) { width: 6%; } /* Total Qty */
      th:nth-child(12), td:nth-child(12) { width: 8%; } /* Active Customers */
      th:nth-child(13), td:nth-child(13) { width: 15%; }/* Sale Remarks */
    `);
        printWindow.document.write('</style></head><body>');
        printWindow.document.write('<h3>SortOrder List</h3>');

        // First Row for Route, Order Taken By, and Order Date
        const firstRowData = routeFilteredData[0];
        if (firstRowData) {
            printWindow.document.write('<div style="margin-bottom: 10px;">');
            printWindow.document.write(
                `<p style="font-size:12px;">
            <strong>Route:</strong> ${firstRowData.routeName || ''} 
            || <strong>Order Taken by:</strong> ${firstRowData.orderTakenBy || ''} 
            || <strong>Order Date:</strong> ${firstRowData.orderDate ? new Date(firstRowData.orderDate).toLocaleDateString('en-GB') : ''}
        </p>`
            );
            printWindow.document.write('</div>');
        }


        // Start Table
        printWindow.document.write('<table>');
        printWindow.document.write('<thead>');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th>Sl.No</th>');
        printWindow.document.write('<th>Order Type</th>');
        printWindow.document.write('<th>Product Category</th>');
        printWindow.document.write('<th>Category</th>');
        printWindow.document.write('<th>Code</th>');
        printWindow.document.write('<th>Item</th>');
        printWindow.document.write('<th>UOM</th>');
        printWindow.document.write('<th>Quantity</th>');
        printWindow.document.write('<th>Bundle</th>');
        printWindow.document.write('<th>Pieces</th>');
        printWindow.document.write('<th>Total Qty</th>');
        printWindow.document.write('<th>Active Customers</th>');
        printWindow.document.write('<th>Sale Remarks</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        routeFilteredData.forEach((rowData, index) => {
            const showOrderTypeName = index === 0 || rowData.OrderTypeName !== routeFilteredData[index - 1].OrderTypeName;
            const showProductCategory = index === 0 || rowData.productCategory !== routeFilteredData[index - 1].productCategory;
            const showCategory = index === 0 || rowData.category !== routeFilteredData[index - 1].category;
            const showCustomerId = index === 0 || rowData.CustomerId !== routeFilteredData[index - 1].CustomerId;
            const showsaleremarks = index === 0 || rowData.saleremarks !== routeFilteredData[index - 1].saleremarks;

            printWindow.document.write('<tr>');
            printWindow.document.write(`<td>${index + 1}</td>`);
            printWindow.document.write(`<td>${showOrderTypeName ? rowData.OrderTypeName : ''}</td>`);
            printWindow.document.write(`<td>${showProductCategory ? rowData.productCategory : ''}</td>`);
            printWindow.document.write(`<td>${showCategory ? rowData.category : ''}</td>`);
            printWindow.document.write(`<td>${rowData.itemCode || ''}</td>`);
            printWindow.document.write(`<td>${rowData.item || ''}</td>`);
            printWindow.document.write(`<td>${rowData.kilogram || ''}</td>`);
            printWindow.document.write(`<td>${rowData.quantity || ''}</td>`);
            printWindow.document.write(`<td>${rowData.bundle || '0'}</td>`);
            printWindow.document.write(`<td>${rowData.pieces || '0'}</td>`);
            printWindow.document.write(`<td>${rowData.totalkilogram || ''}</td>`);
            printWindow.document.write(`<td>${showCustomerId ? rowData.CustomerId : ''}</td>`);
            printWindow.document.write(`<td>${showsaleremarks ? rowData.saleremarks : ''}</td>`);
            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };

    //excel

    const handleExportExcel = async () => {
        try {
            if (!routeFilteredData || routeFilteredData.length === 0) {
                alert("No data available to export.");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Sort Order List");

            const thinBorder = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };

            // ===== TITLE SECTION =====
            worksheet.mergeCells("A1:M1");
            worksheet.getCell("A1").value = "SORT ORDER LIST";
            worksheet.getCell("A1").font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
            worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
            worksheet.getCell("A1").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF739072" } };
            worksheet.getCell("A1").border = thinBorder;

            // ===== INFO SECTION =====
            const firstRow = routeFilteredData[0];
            worksheet.mergeCells("A2:D2");
            worksheet.getCell("A2").value = `Route: ${firstRow?.routeName || "N/A"}`;
            worksheet.getCell("A2").font = { bold: true, size: 11 };
            worksheet.getCell("A2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("A2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("A2").border = thinBorder;

            worksheet.mergeCells("E2:H2");
            worksheet.getCell("E2").value = `Order Taken by: ${firstRow?.orderTakenBy || "N/A"}`;
            worksheet.getCell("E2").font = { bold: true, size: 11 };
            worksheet.getCell("E2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("E2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("E2").border = thinBorder;

            worksheet.mergeCells("I2:M2");
            worksheet.getCell("I2").value = `Order Date: ${firstRow?.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : "N/A"}`;
            worksheet.getCell("I2").font = { bold: true, size: 11 };
            worksheet.getCell("I2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("I2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("I2").border = thinBorder;

            // ===== HEADER ROW =====
            const headerRow = worksheet.addRow([
                "Sl.No",
                "Order Type",
                "Product Category",
                "Category",
                "Code",
                "Item",
                "UOM (Kgs)",
                "Quantity (no. pieces)",
                "Bundle",
                "Pieces",
                "Total Qty (kgs)",
                "Active Customers",
                "Remarks"
            ]);

            headerRow.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
            headerRow.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF739072" } };
            headerRow.height = 30;
            headerRow.eachCell((cell) => {
                cell.border = thinBorder;
            });

            // ===== DATA ROWS =====
            routeFilteredData.forEach((rowData, index) => {
                const showOrderTypeName = index === 0 || rowData.OrderTypeName !== routeFilteredData[index - 1].OrderTypeName;
                const showProductCategory = index === 0 || rowData.productCategory !== routeFilteredData[index - 1].productCategory;
                const showCategory = index === 0 || rowData.category !== routeFilteredData[index - 1].category;
                const showCustomerId = index === 0 || rowData.CustomerId !== routeFilteredData[index - 1].CustomerId;
                const showsaleremarks = index === 0 || rowData.saleremarks !== routeFilteredData[index - 1].saleremarks;
                const isGrandTotal = rowData.ordertype?.toLowerCase() === 'grand total';

                const dataRow = worksheet.addRow([
                    index + 1,
                    showOrderTypeName ? (rowData.OrderTypeName || '') : '',
                    showProductCategory ? (rowData.productCategory || '') : '',
                    showCategory ? (rowData.category || '') : '',
                    rowData.itemCode || '',
                    rowData.item || '',
                    rowData.kilogram || '',
                    rowData.quantity || '',
                    rowData.bundle || '0',
                    rowData.pieces || '0',
                    rowData.totalkilogram || '',
                    showCustomerId ? (rowData.CustomerId || '') : '',
                    showsaleremarks ? (rowData.saleremarks || '') : ''
                ]);

                // Apply styling
                dataRow.alignment = { vertical: "middle", wrapText: true };
                dataRow.eachCell((cell, colNumber) => {
                    cell.border = thinBorder;
                    
                    // Center align specific columns
                    if ([1, 5, 8, 9, 10, 12].includes(colNumber)) {
                        cell.alignment = { horizontal: "center", vertical: "middle" };
                    } else if ([11].includes(colNumber)) {
                        cell.alignment = { horizontal: "right", vertical: "middle" };
                    } else {
                        cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
                    }
                });

                // Highlight Grand Total row
                if (isGrandTotal) {
                    dataRow.font = { bold: true, size: 11 };
                    dataRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFF3CD" } };
                } else {
                    // Zebra striping
                    if (index % 2 === 0) {
                        dataRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF8F9FA" } };
                    }
                }
            });

            // ===== COLUMN WIDTHS =====
            worksheet.columns = [
                { width: 8 },   // Sl.No
                { width: 15 },  // Order Type
                { width: 20 },  // Product Category
                { width: 15 },  // Category
                { width: 10 },  // Code
                { width: 25 },  // Item
                { width: 12 },  // UOM
                { width: 12 },  // Quantity
                { width: 10 },  // Bundle
                { width: 10 },  // Pieces
                { width: 12 },  // Total Qty
                { width: 15 },  // Active Customers
                { width: 20 },  // Remarks
            ];

            // ===== PAGE SETUP =====
            worksheet.pageSetup = {
                paperSize: 9, // A4
                orientation: "landscape",
                fitToPage: true,
                fitToWidth: 1,
                fitToHeight: 0,
                margins: {
                    left: 0.3,
                    right: 0.3,
                    top: 0.5,
                    bottom: 0.5,
                    header: 0.1,
                    footer: 0.1,
                },
            };

            // ===== SAVE FILE =====
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), `SortOrderList_${firstRow?.routeName || "Route"}.xlsx`);
        } catch (error) {
            console.error("❌ Excel Export Failed:", error);
            alert("Error while exporting Excel. Check console for details.");
        }
    };



    // Excel export for Actual Order Summary
    const handleActualOrderExcel = async () => {
        try {
            if (!filteredData || filteredData.length === 0) {
                alert("No data available to export.");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Actual Order Summary");

            const thinBorder = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };

            // Title
            worksheet.mergeCells("A1:P1");
            worksheet.getCell("A1").value = "ACTUAL ORDER SUMMARY";
            worksheet.getCell("A1").font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
            worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
            worksheet.getCell("A1").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2c5f7c" } };
            worksheet.getCell("A1").border = thinBorder;

            // Info Section
            const firstRow = filteredData[0];
            worksheet.mergeCells("A2:E2");
            worksheet.getCell("A2").value = `Route: ${firstRow?.routeName || "N/A"}`;
            worksheet.getCell("A2").font = { bold: true, size: 11 };
            worksheet.getCell("A2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("A2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("A2").border = thinBorder;

            worksheet.mergeCells("F2:J2");
            worksheet.getCell("F2").value = `Order Taken by: ${firstRow?.orderTakenby || "N/A"}`;
            worksheet.getCell("F2").font = { bold: true, size: 11 };
            worksheet.getCell("F2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("F2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("F2").border = thinBorder;

            worksheet.mergeCells("K2:P2");
            worksheet.getCell("K2").value = `Order Date: ${firstRow?.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : "N/A"}`;
            worksheet.getCell("K2").font = { bold: true, size: 11 };
            worksheet.getCell("K2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("K2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("K2").border = thinBorder;

            // Header Row
            const headerRow = worksheet.addRow([
                "S.No", "R.SeqNo", "Customer", "Product Category", "Code", "Item",
                "UOM (Kgs)", "Quantity (No. of pieces)", "Bundle", "Pieces",
                "Total Qty (KGS)", "Rate (Per Piece)", "Taxable Amt", "Total GST Amt",
                "Total Amt", "Sale Remarks"
            ]);

            headerRow.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
            headerRow.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2c5f7c" } };
            headerRow.height = 30;
            headerRow.eachCell((cell) => { cell.border = thinBorder; });

            // Data Rows
            filteredData.forEach((item, index, array) => {
                const previousItem = array[index - 1];
                const isFirstRowForCustomer = !previousItem || previousItem.CustomerName !== item.CustomerName;
                const isFirstRowForCustomerRouteNo = !previousItem || previousItem.SequenceNo !== item.SequenceNo;
                const showProductCategory = !previousItem || previousItem.productCategory !== item.productCategory;
                const showsaleremarks = index === 0 || item.Remarks !== array[index - 1].Remarks;
                const isHighlighted = item.routeName === 'Total' || item.CustomerName?.toLowerCase().includes('total');

                const dataRow = worksheet.addRow([
                    index + 1,
                    isFirstRowForCustomerRouteNo ? item.SequenceNo : '',
                    isFirstRowForCustomer ? item.CustomerName : '',
                    showProductCategory ? item.productCategory : '',
                    item.itemCode,
                    item.item,
                    item.kilogram,
                    item.quantity,
                    item.bundle,
                    item.pieces,
                    item.totalquantity,
                    item.RatePerKg ? parseFloat(item.RatePerKg).toFixed(2) : '0.00',
                    item.taxableamount ? parseFloat(item.taxableamount).toFixed(2) : '0.00',
                    item.gstamount ? parseFloat(item.gstamount).toFixed(2) : '0.00',
                    item.totalAmount ? parseFloat(item.totalAmount).toFixed(2) : '0.00',
                    showsaleremarks ? item.Remarks : ''
                ]);

                dataRow.eachCell((cell, colNumber) => {
                    cell.border = thinBorder;
                    if ([1, 2, 5, 7, 8, 9, 10].includes(colNumber)) {
                        cell.alignment = { horizontal: "center", vertical: "middle" };
                    } else if ([11, 12, 13, 14, 15].includes(colNumber)) {
                        cell.alignment = { horizontal: "right", vertical: "middle" };
                    } else {
                        cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
                    }
                });

                if (isHighlighted) {
                    dataRow.font = { bold: true, size: 11 };
                    dataRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFF3CD" } };
                } else if (index % 2 === 0) {
                    dataRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF8F9FA" } };
                }
            });

            // Column Widths
            worksheet.columns = [
                { width: 8 }, { width: 10 }, { width: 20 }, { width: 18 }, { width: 10 },
                { width: 25 }, { width: 12 }, { width: 12 }, { width: 10 }, { width: 10 },
                { width: 12 }, { width: 12 }, { width: 12 }, { width: 12 }, { width: 12 }, { width: 20 }
            ];

            worksheet.pageSetup = {
                paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1, fitToHeight: 0,
                margins: { left: 0.3, right: 0.3, top: 0.5, bottom: 0.5, header: 0.1, footer: 0.1 }
            };

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), `ActualOrderSummary_${firstRow?.routeName || "Route"}.xlsx`);
        } catch (error) {
            console.error("❌ Excel Export Failed:", error);
            alert("Error while exporting Excel.");
        }
    };

    // Excel export for Additional Order Summary
    const handleAdditionalOrderExcel = async () => {
        try {
            if (!addFilteredData || addFilteredData.length === 0) {
                alert("No data available to export.");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Additional Order Summary");

            const thinBorder = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };

            // Title
            worksheet.mergeCells("A1:P1");
            worksheet.getCell("A1").value = "ADDITIONAL ORDER SUMMARY";
            worksheet.getCell("A1").font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
            worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
            worksheet.getCell("A1").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF6b4c7a" } };
            worksheet.getCell("A1").border = thinBorder;

            // Info Section
            const firstRow = addFilteredData[0];
            worksheet.mergeCells("A2:E2");
            worksheet.getCell("A2").value = `Route: ${firstRow?.routeName || "N/A"}`;
            worksheet.getCell("A2").font = { bold: true, size: 11 };
            worksheet.getCell("A2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("A2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("A2").border = thinBorder;

            worksheet.mergeCells("F2:J2");
            worksheet.getCell("F2").value = `Order Taken by: ${firstRow?.orderTakenby || "N/A"}`;
            worksheet.getCell("F2").font = { bold: true, size: 11 };
            worksheet.getCell("F2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("F2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("F2").border = thinBorder;

            worksheet.mergeCells("K2:P2");
            worksheet.getCell("K2").value = `Order Date: ${firstRow?.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : "N/A"}`;
            worksheet.getCell("K2").font = { bold: true, size: 11 };
            worksheet.getCell("K2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("K2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("K2").border = thinBorder;

            // Header Row
            const headerRow = worksheet.addRow([
                "Sl.No", "", "Customer Name", "Category", "Code", "Item",
                "UOM (Kgs)", "Quantity (no. pieces)", "Bundle", "Pieces",
                "Total Qty (kgs)", "Rate (per Kg)", "Taxable Amt", "Total GST Amt",
                "Total Amt", "Remarks"
            ]);

            headerRow.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
            headerRow.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF6b4c7a" } };
            headerRow.height = 30;
            headerRow.eachCell((cell) => { cell.border = thinBorder; });

            // Data Rows
            addFilteredData.forEach((item, index) => {
                const showCustomerName = index === 0 || item.CustomerName !== addFilteredData[index - 1].CustomerName;
                const showRemarks = index === 0 || item.Remarks !== addFilteredData[index - 1].Remarks;
                const showProductCategory = index === 0 || item.productCategory !== addFilteredData[index - 1].productCategory;
                const isHighlightedRow = item.CustomerName?.toLowerCase().includes('total for');

                const dataRow = worksheet.addRow([
                    index + 1,
                    item.total || '',
                    showCustomerName ? item.CustomerName : '',
                    showProductCategory ? item.productCategory : '',
                    item.itemCode,
                    item.item,
                    item.kilogram,
                    item.quantity,
                    item.bundle,
                    item.pieces,
                    item.totalquantity,
                    item.RatePerKg,
                    item.taxableamount ? parseFloat(item.taxableamount).toFixed(2) : '0.00',
                    item.gstamount ? parseFloat(item.gstamount).toFixed(2) : '0.00',
                    item.totalAmount ? parseFloat(item.totalAmount).toFixed(2) : '0.00',
                    showRemarks ? item.Remarks : ''
                ]);

                dataRow.eachCell((cell, colNumber) => {
                    cell.border = thinBorder;
                    if ([1, 2, 5, 8, 9, 10].includes(colNumber)) {
                        cell.alignment = { horizontal: "center", vertical: "middle" };
                    } else if ([11, 12, 13, 14, 15].includes(colNumber)) {
                        cell.alignment = { horizontal: "right", vertical: "middle" };
                    } else {
                        cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
                    }
                });

                if (isHighlightedRow) {
                    dataRow.font = { bold: true, size: 11 };
                    dataRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFF3CD" } };
                } else if (index % 2 === 0) {
                    dataRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF8F9FA" } };
                }
            });

            // Column Widths
            worksheet.columns = [
                { width: 8 }, { width: 10 }, { width: 20 }, { width: 18 }, { width: 10 },
                { width: 25 }, { width: 12 }, { width: 12 }, { width: 10 }, { width: 10 },
                { width: 12 }, { width: 12 }, { width: 12 }, { width: 12 }, { width: 12 }, { width: 20 }
            ];

            worksheet.pageSetup = {
                paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1, fitToHeight: 0,
                margins: { left: 0.3, right: 0.3, top: 0.5, bottom: 0.5, header: 0.1, footer: 0.1 }
            };

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), `AdditionalOrderSummary_${firstRow?.routeName || "Route"}.xlsx`);
        } catch (error) {
            console.error("❌ Excel Export Failed:", error);
            alert("Error while exporting Excel.");
        }
    };

    // Excel export for Extra Loading Summary
    const handleExtraLoadingExcel = async () => {
        try {
            if (!exFilteredData || exFilteredData.length === 0) {
                alert("No data available to export.");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Extra Loading Summary");

            const thinBorder = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };

            // Title
            worksheet.mergeCells("A1:P1");
            worksheet.getCell("A1").value = "EXTRA LOADING SUMMARY";
            worksheet.getCell("A1").font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
            worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
            worksheet.getCell("A1").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2d7a5f" } };
            worksheet.getCell("A1").border = thinBorder;

            // Info Section
            const firstRow = exFilteredData[0];
            worksheet.mergeCells("A2:E2");
            worksheet.getCell("A2").value = `Route: ${firstRow?.routeName || "N/A"}`;
            worksheet.getCell("A2").font = { bold: true, size: 11 };
            worksheet.getCell("A2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("A2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("A2").border = thinBorder;

            worksheet.mergeCells("F2:J2");
            worksheet.getCell("F2").value = `Order Taken by: ${firstRow?.orderTakenby || "N/A"}`;
            worksheet.getCell("F2").font = { bold: true, size: 11 };
            worksheet.getCell("F2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("F2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("F2").border = thinBorder;

            worksheet.mergeCells("K2:P2");
            worksheet.getCell("K2").value = `Order Date: ${firstRow?.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : "N/A"}`;
            worksheet.getCell("K2").font = { bold: true, size: 11 };
            worksheet.getCell("K2").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.getCell("K2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            worksheet.getCell("K2").border = thinBorder;

            // Header Row
            const headerRow = worksheet.addRow([
                "Sl.No", "", "Product Category", "Category", "Code", "Item",
                "UOM (Kgs)", "Quantity (no. pieces)", "Bundle", "Pieces",
                "Total Qty (kgs)", "Rate (per Kg)", "Taxable Amt", "Total GST Amt",
                "Total Amt", "Remarks"
            ]);

            headerRow.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
            headerRow.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2d7a5f" } };
            headerRow.height = 30;
            headerRow.eachCell((cell) => { cell.border = thinBorder; });

            // Data Rows
            exFilteredData.forEach((item, index) => {
                const showRemarks = index === 0 || item.Remarks !== exFilteredData[index - 1].Remarks;
                const showProductCategory = index === 0 || item.productCategory !== exFilteredData[index - 1].productCategory;
                const showCategory = index === 0 || item.Category !== exFilteredData[index - 1].Category;
                const isGrandTotal = item.total === 'GRAND TOTAL';

                const dataRow = worksheet.addRow([
                    index + 1,
                    item.total || '',
                    showProductCategory ? item.productCategory : '',
                    showCategory ? item.Category : '',
                    item.itemCode,
                    item.item,
                    item.kilogram,
                    item.quantity,
                    item.bundle,
                    item.pieces,
                    item.totalkilogram,
                    item.RatePerKg,
                    item.taxableamount ? parseFloat(item.taxableamount).toFixed(2) : '0.00',
                    item.gstamount ? parseFloat(item.gstamount).toFixed(2) : '0.00',
                    item.totalAmount ? parseFloat(item.totalAmount).toFixed(2) : '0.00',
                    showRemarks ? item.Remarks : ''
                ]);

                dataRow.eachCell((cell, colNumber) => {
                    cell.border = thinBorder;
                    if ([1, 2, 5, 8, 9, 10].includes(colNumber)) {
                        cell.alignment = { horizontal: "center", vertical: "middle" };
                    } else if ([11, 12, 13, 14, 15].includes(colNumber)) {
                        cell.alignment = { horizontal: "right", vertical: "middle" };
                    } else {
                        cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
                    }
                });

                if (isGrandTotal) {
                    dataRow.font = { bold: true, size: 11 };
                    dataRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFd4edda" } };
                } else if (index % 2 === 0) {
                    dataRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF8F9FA" } };
                }
            });

            // Column Widths
            worksheet.columns = [
                { width: 8 }, { width: 10 }, { width: 20 }, { width: 15 }, { width: 10 },
                { width: 25 }, { width: 12 }, { width: 12 }, { width: 10 }, { width: 10 },
                { width: 12 }, { width: 12 }, { width: 12 }, { width: 12 }, { width: 12 }, { width: 20 }
            ];

            worksheet.pageSetup = {
                paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1, fitToHeight: 0,
                margins: { left: 0.3, right: 0.3, top: 0.5, bottom: 0.5, header: 0.1, footer: 0.1 }
            };

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), `ExtraLoadingSummary_${firstRow?.routeName || "Route"}.xlsx`);
        } catch (error) {
            console.error("❌ Excel Export Failed:", error);
            alert("Error while exporting Excel.");
        }
    };

    //for finding the template with item details (category and weightage)
    const [CustomerandItemOrderSheetdata, setCustomerandItemOrderSheetdata] = useState([]);
    const [ItemData, setItemData] = useState([]);



    useEffect(() => {
        fetchCustomerItemData();
    }, []);

    const fetchCustomerItemData = async () => {
        try {
            // Fetch Customer & Item Data
            const response = await fetchData('CustomerItemOrdersheet', `/${companyId}/${tripid}`, token);

            if (response.responseCode === '1111') {
                setCustomerandItemOrderSheetdata(response.response_data || []);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };


    const handleExportTempExcel = async (response_data = []) => {
        try {
            if (!Array.isArray(response_data) || response_data.length === 0) {
                //alert("No data found for export.");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Order Sheet");

            const thinBorder = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };

            // ===== HEADER SECTION =====
            worksheet.mergeCells("A1:Z1");
            worksheet.getCell("A1").value = "ORDER SHEET";
            worksheet.getCell("A1").font = { bold: true, size: 14 };
            worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
            worksheet.getCell("A1").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };

            worksheet.mergeCells("A2:F2");
            worksheet.getCell("A2").value = `ROUTE: ${response_data[0]?.RouteName || "N/A"}`;
            worksheet.getCell("A2").alignment = { horizontal: "left", vertical: "middle" };

            worksheet.mergeCells("G2:Z2");
            worksheet.getCell("G2").value = "Order Details";
            worksheet.getCell("G2").alignment = { horizontal: "center", vertical: "middle" };
            worksheet.getCell("G2").font = { bold: true };

            worksheet.mergeCells("A3:F3");
            worksheet.getCell("A3").value = `Date From: ${fromDate || "00-00-2025"} To ${toDate || "00-00-2025"}`;
            worksheet.getCell("A3").alignment = { horizontal: "left", vertical: "middle" };

            worksheet.mergeCells("G3:Z3");
            worksheet.getCell("G3").value = "CATEGORY & VARIANT";
            worksheet.getCell("G3").alignment = { horizontal: "center", vertical: "middle" };
            worksheet.getCell("G3").font = { bold: true };

            worksheet.mergeCells("A4:C4");
            worksheet.getCell("A4").value = `ASM/SO/SE:`;
            worksheet.getCell("A4").alignment = { horizontal: "left", vertical: "middle" };

            worksheet.mergeCells("D4:H4");
            worksheet.getCell("D4").value = `Date of Supply: ${toDate || "00-00-2025"}`;
            worksheet.getCell("D4").alignment = { horizontal: "left", vertical: "middle" };
            worksheet.mergeCells("I4:Z4");


            // // Apply border and fill for header rows
            // for (let i = 1; i <= 4; i++) {
            //     worksheet.getRow(i).eachCell((cell) => {
            //         cell.border = thinBorder;
            //         cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
            //     });
            // }
            const lastCol = 50; // Adjust as per your sheet width

            for (let i = 1; i <= 4; i++) {
                for (let j = 1; j <= lastCol; j++) {
                    const cell = worksheet.getRow(i).getCell(j);
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3E3" } };
                    cell.border = thinBorder;
                }
            }


            // ===== FIXED COLUMNS =====
            const fixedHeaders = [
                "Shop Order",
                "Customer Name",
                "Opening Balance",
                "Last Date of Sale",
                "Payment Mode",
            ];

            // ===== BUILD CATEGORY-WEIGHT MAP =====
            const categoryMap = {};
            response_data.forEach((cust) => {
                cust.ItemList?.forEach((item) => {
                    const category = item.Category?.trim();
                    const weight = item.BagWeight?.trim();
                    if (category && weight) {
                        if (!categoryMap[category]) categoryMap[category] = new Set();
                        categoryMap[category].add(weight);
                    }
                });
            });

            const categoryColumns = Object.entries(categoryMap).map(([category, weightsSet]) => ({
                name: category,
                weights: Array.from(weightsSet).sort((a, b) => parseFloat(a) - parseFloat(b)),
            }));

            // ===== HEADER ROWS =====
            const headerStartRow = 5;
            const headerRow1 = [...fixedHeaders];
            categoryColumns.forEach((col) => {
                headerRow1.push(col.name);
                for (let i = 1; i < col.weights.length; i++) headerRow1.push(null);
            });
            headerRow1.push("Remarks");
            worksheet.insertRow(headerStartRow, headerRow1);

            const headerRow2 = [
                ...fixedHeaders.map(() => null),
                ...categoryColumns.flatMap((col) => col.weights.map((w) => `${w}`)),
                "Remarks",
            ];
            worksheet.insertRow(headerStartRow + 1, headerRow2);

            // ===== MERGE CATEGORY CELLS =====
            let colStart = fixedHeaders.length + 1;
            categoryColumns.forEach((col) => {
                const colEnd = colStart + col.weights.length - 1;
                worksheet.mergeCells(headerStartRow, colStart, headerStartRow, colEnd);
                worksheet.getCell(headerStartRow, colStart).alignment = { horizontal: "center", vertical: "middle" };
                worksheet.getCell(headerStartRow, colStart).font = { bold: true };
                colStart = colEnd + 1;
            });

            // ===== STYLE HEADER ROWS =====
            [worksheet.getRow(headerStartRow), worksheet.getRow(headerStartRow + 1)].forEach((row) => {
                row.font = { bold: true };
                row.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
                row.eachCell((cell) => (cell.border = thinBorder));
            });

            // ===== CUSTOMER ROWS =====
            let dataStartRow = headerStartRow + 2;
            response_data.forEach((cust, idx) => {
                const row = [
                    idx + 1,
                    cust.CustomerName || "",
                    cust.OpeningBalance ?? 0,
                    cust.LastSaleDate ? new Date(cust.LastSaleDate).toLocaleDateString("en-GB") : "",
                    cust.PaymentMode || "",
                ];

                const itemMap = {};
                cust.ItemList?.forEach((item) => {
                    const category = item.Category?.trim();
                    const weight = item.BagWeight?.trim();
                    if (category && weight) {
                        if (!itemMap[category]) itemMap[category] = {};
                        // 👇 show ordered quantity from SaleOrder table
                        // itemMap[category][weight] = item.OrderedQty ?? "";
                        itemMap[category][weight] =
                            item.OrderedQty && item.OrderedQty !== 0 ? item.OrderedQty : "";

                    }
                });

                categoryColumns.forEach((col) => {
                    col.weights.forEach((weight) => {
                        row.push(itemMap[col.name]?.[weight] ?? "");
                    });
                });

                row.push(""); // Remarks column
                const addedRow = worksheet.insertRow(dataStartRow++, row);
                addedRow.eachCell((cell) => (cell.border = thinBorder));
            });

            // ===== COLUMN WIDTHS =====
            worksheet.columns.forEach((col, i) => {
                if (i === 0) col.width = 8; // Shop Order
                else if (i === 1) col.width = 30; // Customer
                else col.width = 10; // Others
            });

            // ===== PAGE SETUP (A4) =====
            worksheet.pageSetup = {
                paperSize: 9, // A4
                orientation: "landscape",
                fitToPage: true,
                fitToWidth: 1,
                fitToHeight: 0,
                margins: {
                    left: 0.3,
                    right: 0.3,
                    top: 0.5,
                    bottom: 0.5,
                    header: 0.1,
                    footer: 0.1,
                },
            };

            // ===== SAVE FILE =====
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), `OrderSheet_${response_data[0]?.RouteName || "Route"}.xlsx`);
        } catch (error) {
            console.error("❌ Excel Export Failed:", error);
            alert("Error while exporting Excel. Check console for details.");
        }
    };



    const getRowColor = (balanceQty, weight) => {
        if (balanceQty <= weight / 2) {
            return { backgroundColor: '#FFD0D0' };
        }
        else if (balanceQty <= weight / 3) {
            return { backgroundColor: '#FFFFE0' };
        }
        else {
            return {}; // Default style
        }
    };

    function moveGrandTotalToEnd(routeFilteredData) {
        let grandTotalRow;
        let filteredData = routeFilteredData.filter((item) => {
            if (item.ordertype === 'Grand Total') {
                grandTotalRow = item;
                return false;
            }
            return true;
        });

        if (grandTotalRow) {
            filteredData.push(grandTotalRow);
        }

        return filteredData;
    }

    // Use the function in your rendering logic
    let sortedData = moveGrandTotalToEnd(routeFilteredData);


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '100%' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>SALE ORDER</h6>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontWeight: 'normal', marginLeft: '-120px' }}>Trip Date : {orderDate && new Date(orderDate).toLocaleDateString('en-GB')}</h6>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontWeight: 'normal', marginLeft: '-150px' }}>Route : {Route}</h6>
            </div>

            <div className="w-full mb-2 flex flex-wrap justify-between">
                <div className="flex flex-wrap">
                    <Button
                        variant="contained"
                        onClick={() => openroutedatamodal()}
                        style={{
                            margin: '5px',
                            fontSize: '12px',
                            fontWeight: 'bolder',
                            background: 'linear-gradient(to right, darkgreen, darkgreen)',
                            borderRadius: '50px',
                            padding: '6px 12px',
                        }}
                    >
                        Sort Order List
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => opendatamodal()}
                        style={{
                            margin: '5px',
                            fontSize: '12px',
                            fontWeight: 'bolder',
                            background: 'linear-gradient(to right, brown, brown)',
                            borderRadius: '50px',
                            padding: '6px 12px',
                        }}
                    >
                        ActualOrder_Summary
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => openAdddatamodal()}
                        style={{
                            margin: '5px',
                            fontSize: '12px',
                            fontWeight: 'bolder',
                            background: 'linear-gradient(to right, #522258, #522258)',
                            borderRadius: '50px',
                            padding: '6px 12px',
                        }}
                    >
                        AdditionalOrder_Summary
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => openExdatamodal()}
                        style={{
                            margin: '5px',
                            fontSize: '12px',
                            fontWeight: 'bolder',
                            background: 'linear-gradient(to right, #180161, #180161)',
                            borderRadius: '50px',
                            padding: '6px 12px',
                        }}
                    >
                        ExtraLoading_Summary
                    </Button>
                </div>

                <div className="flex flex-wrap">

                    <Button
                        variant="contained"
                        onClick={() => handleExportTempExcel(CustomerandItemOrderSheetdata)}
                        style={{
                            margin: '5px',
                            fontSize: '12px',
                            backgroundColor: '#40534C',
                            borderRadius: '50px',
                            color: 'black',
                            padding: '6px 12px',
                        }}
                    >
                        <span style={{ color: 'white', fontWeight: 'bolder' }}>Excel Template_sheet</span>
                    </Button>



                    {data.isRouteClose === false ? (
                        <Tooltip title="Closing SaleOrder From this Route?">
                            <Button
                                variant="contained"
                                style={{
                                    background: '#006769',
                                    margin: '5px',
                                    fontSize: '12px',
                                    borderRadius: '50px',
                                    padding: '6px 12px',
                                }}
                                onClick={() => openConfirmDialog(tripid)}
                            >
                                <span style={{ color: 'white', fontWeight: 'bolder' }}> Route Close</span>
                            </Button>
                        </Tooltip>
                    ) : (
                        <Tooltip title="Route already closed">
                            <Button
                                variant="contained"
                                style={{
                                    background: '#006769',
                                    margin: '5px',
                                    fontSize: '12px',
                                    borderRadius: '50px',
                                    padding: '6px 12px',
                                }}
                                onClick={() => openConfirmDialog(tripid)}
                            >
                                <span style={{ color: 'white', fontWeight: 'bolder' }}> Route Close</span>
                            </Button>
                        </Tooltip>
                    )}

                    <Link to={`/AddtionalOrderIndex/${id}`}>
                        <Button
                            variant="contained"
                            style={{
                                margin: '5px',
                                fontSize: '12px',
                                backgroundColor: '#32012F',
                                borderRadius: '50px',
                                padding: '6px 12px',
                            }}
                        >
                            <span style={{ color: 'white', fontWeight: 'bolder' }}> Additional Order</span>
                        </Button>
                    </Link>

                    <Link to={`/ExtraloadingIndex/${id}`}>
                        <Button
                            style={{
                                background: '#FF9800',
                                color: 'white',
                                margin: '5px',
                                fontSize: '12px',
                                borderRadius: '50px',
                                fontWeight: 'bolder',
                                padding: '6px 12px',
                            }}
                        >
                            ExtraLoading
                        </Button>
                    </Link>
                </div>
            </div>

            <div className='mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '1%', padding: '4px' }}>R.No</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '16%', padding: '4px' }}>Name</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '7%', padding: '4px' }}>Ph:No</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '7%', padding: '4px' }}>L.Bill Date</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '7%', padding: '4px' }}>L.Bill (₹)</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '7%', padding: '4px' }}>Outstanding</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '7%', padding: '4px' }}>Pay Option</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '7%', padding: '4px' }}>Item Count</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '12%', padding: '4px' }}>Opening-Closing (<AccessTimeIcon />)</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '7%', padding: '4px' }}>Lunch (<AccessTimeIcon />)</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '7%', padding: '4px' }}>Rating</TableCell>
                                <TableCell style={{ fontSize: '14px', fontWeight: 'bold', gap: '4px', width: '23%', padding: '4px' }}>Remark</TableCell>

                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell colSpan={12} style={{ textAlign: 'center', padding: '10px' }}>
                                        Loading...
                                    </TableCell>
                                </TableRow>
                            ) : data.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={12} style={{ textAlign: 'center', padding: '10px' }}>
                                        No records found
                                    </TableCell>
                                </TableRow>
                            ) : (
                                data.map((item, index) => (
                                    <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'}>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '1%' }}>
                                            {item.routeSequenceNo}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '17%' }}>
                                            <span>{item.name} {item.addressLine1} {item.customerCode}</span>
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '7%' }}>
                                            {item.contactNumber1} , {item.contactNumber2}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '2%' }}>
                                            {item.latestBillDate ? new Date(item.latestBillDate).toLocaleDateString('en-GB') : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', textAlign: 'right', width: '7%' }}>
                                            {Number(item.latestBillAmount).toFixed(2)}
                                        </TableCell>
                                        {/* <TableCell style={{ fontSize: '12px', padding: '2px', textAlign: 'right', width: '7%' }}>
                                            {Number(item.outstandingbalance).toFixed(2)}
                                        </TableCell> */}
                                        <TableCell
                                            style={{ fontSize: '12px', padding: '2px', textAlign: 'right', width: '7%' }}
                                        >
                                            {item.closingBalance != null
                                                ? `${Number(item.closingBalance).toFixed(2)} ${item.closingBalanceType ?? ''}`
                                                : '0.00'}
                                        </TableCell>

                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '7%', textAlign: 'center' }}>
                                            {item.paymentType}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '7%', textAlign: 'center' }}>
                                            {item.itemcount}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '7%', textAlign: 'center' }}>
                                            {item.openingTime}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '7%', textAlign: 'center' }}>
                                            {item.lunchBreak}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '7%', textAlign: 'center' }}>
                                            {item.customerReview}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '12px', padding: '2px', width: '23%', textAlign: 'center' }}>
                                            {item.remarks}
                                        </TableCell>

                                        {!item.isRouteClose && (
                                            <TableCell style={{ fontSize: '12px', padding: '2px', width: '3%' }}>
                                                {item.saleorderfinish === true ? (
                                                    <Link to={`/SaleOrderCreate/${item.id}/${tripid}`}>
                                                        <Tooltip title="Create Sale Order">
                                                            <IconButton style={{ height: '40px' }}>
                                                                <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Link>
                                                ) : (
                                                    <Tooltip title="Edit the Sale Order">
                                                        <Link to={`/SaleOrderEdit/${item.saleorderid}`}>
                                                            <IconButton style={{ height: '40px' }}>
                                                                <EditIcon style={{ color: 'blueviolet' }} />
                                                            </IconButton>
                                                        </Link>
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                        )}
                                    </TableRow>
                                ))
                            )}
                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Sale order Completed?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you Completed taking SaleOrder From This Route?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    No
                                </button>
                                <button
                                    onClick={() => {
                                        handleDelete();
                                        window.location.reload();
                                    }}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Yes
                                </button>

                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>

                {showModal && (
                    <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                        <div style={getModalWrapperStyles()}>
                            <div style={getModalContentStyles()}>

                                <div style={getButtonContainerStyles()}>
                                    <Button
                                        sx={getButtonStyles('excel')}
                                        onClick={handleActualOrderExcel}
                                    >
                                        Excel
                                    </Button>
                                    <Button
                                        sx={getButtonStyles('print')}
                                        onClick={handleACtualPrint}
                                    >
                                        Print
                                    </Button>

                                    <Button
                                        sx={getButtonStyles('close')}
                                        onClick={closeModal}
                                    >
                                        Close
                                    </Button>
                                </div>

                                <h6 style={getModalTitleStyles()}>ACTUAL ORDER SUMMARY</h6>

                                {/* Info Section */}
                                {filteredData && filteredData.length > 0 && (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginBottom: '12px',
                                        padding: '8px 12px',
                                        backgroundColor: '#f3f3e3',
                                        borderRadius: '6px',
                                        border: '1px solid #ddd'
                                    }}>
                                        <div style={{ flex: 1 }}>
                                            <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Route:</strong>
                                            <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                                {filteredData[0]?.routeName || 'N/A'}
                                            </span>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Order Taken by:</strong>
                                            <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                                {filteredData[0]?.orderTakenby || 'N/A'}
                                            </span>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Order Date:</strong>
                                            <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                                {filteredData[0]?.orderDate ? new Date(filteredData[0].orderDate).toLocaleDateString('en-GB') : 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                )}

                                <TableContainer component={Paper} sx={getTableContainerStyles()}>
                                    <Table sx={getTableStyles()}>
                                        <TableHead sx={getTableHeadStyles('actual')}>
                                            <TableRow>
                                                <TableCell sx={getTableHeaderCellStyles('center')}>S.No</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('center')}>R.SeqNo</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('left')}>Customer</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('left')}>Product Category</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('center')}>Code</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('left')}>Item</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('center')}>UOM<br /><span style={{ fontSize: '10px' }}>(Kgs)</span></TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('center')}>Quantity<br /><span style={{ fontSize: '10px' }}>(No. of pieces)</span></TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('center')}>Bundle</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('center')}>Pieces</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('center')}>Total Qty<br /><span style={{ fontSize: '10px' }}>(KGS)</span></TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('right')}>Rate<br /><span style={{ fontSize: '10px' }}>(Per Piece)</span></TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('right')}>Taxable Amt</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('right')}>Total GST Amt</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('right')}>Total Amt</TableCell>
                                                <TableCell sx={getTableHeaderCellStyles('left')}>Sale Remarks</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {filteredData && filteredData.length > 0 ? (
                                                filteredData
                                                    .slice()
                                                    .sort((a, b) => parseInt(a.SequenceNo) - parseInt(b.SequenceNo))
                                                    .map((item, index, array) => {
                                                        const previousItem = array[index - 1];
                                                        const isFirstRowForCustomer = !previousItem || previousItem.CustomerName !== item.CustomerName;
                                                        const isFirstRowForCustomerRouteNo = !previousItem || previousItem.SequenceNo !== item.SequenceNo;
                                                        const showProductCategory = !previousItem || previousItem.productCategory !== item.productCategory;
                                                        const showsaleremarks = index === 0 || item.Remarks !== array[index - 1].Remarks;
                                                        const isHighlighted = item.routeName === 'Total' || item.CustomerName?.toLowerCase().includes('total');

                                                        return (
                                                            <TableRow
                                                                key={item.id}
                                                                sx={getTableRowStyles(isHighlighted, 'actual')}
                                                            >
                                                                <TableCell sx={getTableCellStyles('center')}>
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('center', isFirstRowForCustomerRouteNo)}>
                                                                    {isFirstRowForCustomerRouteNo ? item.SequenceNo : ''}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('text', isFirstRowForCustomer)}>
                                                                    {isFirstRowForCustomer ? item.CustomerName : ''}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('text')}>
                                                                    {showProductCategory ? item.productCategory : ''}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('center')}>
                                                                    {item.itemCode}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('text')}>
                                                                    {item.item}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('center', true)}>
                                                                    {item.kilogram}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('center')}>
                                                                    {item.quantity}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('center')}>
                                                                    {item.bundle}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('center')}>
                                                                    {item.pieces}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('numeric')}>
                                                                    {item.totalquantity}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('numeric')}>
                                                                    {formatDecimal(item.RatePerKg)}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('numeric')}>
                                                                    {formatDecimal(item.taxableamount)}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('numeric')}>
                                                                    {formatDecimal(item.gstamount)}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('numeric')}>
                                                                    {formatDecimal(item.totalAmount)}
                                                                </TableCell>
                                                                <TableCell sx={getTableCellStyles('text')}>
                                                                    {showsaleremarks ? item.Remarks : ''}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={16} sx={getEmptyStateCellStyles()}>
                                                        No data available
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                    </Table>

                                </TableContainer>

                            </div>
                        </div>
                    </Modal >
                )
                }

                <Modal open={routeshowmodel} onClose={closeRouteModal} className={routeshowmodel ? 'notification-modal' : ''}>
                    <div style={getModalWrapperStyles()}>
                        <div style={getModalContentStyles()}>

                            <div style={getButtonContainerStyles()}>
                                <Button
                                    sx={getButtonStyles('excel')}
                                    onClick={handleExportExcel}
                                >
                                    Excel
                                </Button>
                                <Button
                                    sx={getButtonStyles('print')}
                                    onClick={handlePrint}
                                >
                                    Print
                                </Button>
                                <Button
                                    sx={getButtonStyles('close')}
                                    onClick={closeRouteModal}
                                >
                                    Close
                                </Button>
                            </div>
                            <h6 style={getModalTitleStyles()}>Sort Order List</h6>

                            {/* Info Section */}
                            {sortedData && sortedData.length > 0 && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '12px',
                                    padding: '5px',
                                    backgroundColor: '#f3f3e3',
                                    borderRadius: '6px',
                                    border: '1px solid #ddd'
                                }}>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Route:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {sortedData[0]?.routeName || 'N/A'}
                                        </span>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Order Taken by:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {sortedData[0]?.orderTakenBy || 'N/A'}
                                        </span>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Order Date:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {sortedData[0]?.orderDate ? new Date(sortedData[0].orderDate).toLocaleDateString('en-GB') : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            )}

                            <TableContainer component={Paper} sx={getTableContainerStyles()}>
                                <Table sx={getTableStyles()}>
                                    <TableHead sx={getTableHeadStyles('sortOrder')}>
                                        <TableRow>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Sl.No</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Order Type</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Product Category</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Category</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Code</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Item</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>UOM<br /><span style={{ fontSize: '10px' }}>(Kgs)</span></TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Quantity<br /><span style={{ fontSize: '10px' }}>(no. pieces)</span></TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Bundle</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Pieces</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Total Qty<br /><span style={{ fontSize: '10px' }}>(kgs)</span></TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Active Customers</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Remarks</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sortedData && sortedData.length > 0 ? (
                                            sortedData.map((item, index) => {
                                                // Check if this is the first item or if the productCategory and OrderTypeName are different from the previous item
                                                const showProductCategory = index === 0 || item.productCategory !== sortedData[index - 1].productCategory;
                                                const showOrderTypeName = index === 0 || item.OrderTypeName !== sortedData[index - 1].OrderTypeName;
                                                const showCategory = index === 0 || item.category !== sortedData[index - 1].category;
                                                const showCustomerId = index === 0 || item.CustomerId !== sortedData[index - 1].CustomerId;
                                                const showsaleremarks = index === 0 || item.saleremarks !== sortedData[index - 1].saleremarks;
                                                const isGrandTotal = item.ordertype?.toLowerCase() === 'grand total';

                                                return (
                                                    <TableRow
                                                        key={item.id}
                                                        sx={getTableRowStyles(isGrandTotal, 'sortOrder')}
                                                    >
                                                            <TableCell sx={getTableCellStyles('center')}>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('text')}>
                                                                {showOrderTypeName ? item.OrderTypeName : ''}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('text')}>
                                                                {showProductCategory ? item.productCategory : ''}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('text')}>
                                                                {showCategory ? item.category : ''}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('center')}>
                                                                {item.itemCode}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('text')}>
                                                                {item.item}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('text', true)}>
                                                                {item.kilogram}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('center')}>
                                                                {item.quantity}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('center')}>
                                                                {item.bundle}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('center')}>
                                                                {item.pieces}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('numeric')}>
                                                                {item.totalkilogram}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('center')}>
                                                                {showCustomerId ? item.CustomerId : ''}
                                                            </TableCell>
                                                            <TableCell sx={getTableCellStyles('text')}>
                                                                {showsaleremarks ? item.saleremarks : ''}
                                                            </TableCell>
                                                        </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={13} sx={getEmptyStateCellStyles()}>
                                                    No data available
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </Modal>

                {/* AdditionalOrder summary */}
                <Modal open={addshowmodel} onClose={closeaddModal}>
                    <div style={getModalWrapperStyles()}>
                        <div style={getModalContentStyles()}>
                            <div style={getButtonContainerStyles()}>
                                <Button
                                    sx={getButtonStyles('excel')}
                                    onClick={handleAdditionalOrderExcel}
                                >
                                    Excel
                                </Button>
                                <Button
                                    sx={getButtonStyles('print')}
                                    onClick={handleAddPrint}
                                >
                                    Print
                                </Button>
                                <Button
                                    sx={getButtonStyles('close')}
                                    onClick={closeaddModal}
                                >
                                    Close
                                </Button>
                            </div>

                            <h6 style={getModalTitleStyles()}>Additional Order Summary</h6>

                            {/* Info Section */}
                            {addFilteredData && addFilteredData.length > 0 && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '12px',
                                    padding: '8px 12px',
                                    backgroundColor: '#f3f3e3',
                                    borderRadius: '6px',
                                    border: '1px solid #ddd'
                                }}>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Route:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {addFilteredData[0]?.routeName || 'N/A'}
                                        </span>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Order Taken by:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {addFilteredData[0]?.orderTakenby || 'N/A'}
                                        </span>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Order Date:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {addFilteredData[0]?.orderDate ? new Date(addFilteredData[0].orderDate).toLocaleDateString('en-GB') : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            )}

                            <TableContainer component={Paper} sx={getTableContainerStyles()}>
                                <Table sx={getTableStyles()}>
                                    <TableHead sx={getTableHeadStyles('additional')}>
                                        <TableRow>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Sl.No</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}> </TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Customer Name</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Category</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Code</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Item</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>UOM (Kgs)</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Quantity<br />(no. pieces)</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Bundle</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Pieces</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Total Qty<br />(kgs)</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Rate<br />(per Kg)</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Taxable Amt</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Total GST Amt</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Total Amt</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Remarks</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {addFilteredData && addFilteredData.length > 0 ? (
                                            addFilteredData.map((item, index) => {
                                                const showCustomerName = index === 0 || item.CustomerName !== addFilteredData[index - 1].CustomerName;
                                                const showRemarks = index === 0 || item.Remarks !== addFilteredData[index - 1].Remarks;
                                                const showProductCategory = index === 0 || item.productCategory !== addFilteredData[index - 1].productCategory;
                                                const isHighlightedRow = shouldHighlightRow(item, 'additional');

                                                return (
                                                    <TableRow
                                                        key={item.id}
                                                        sx={getTableRowStyles(isHighlightedRow, 'additional')}
                                                    >
                                                        <TableCell sx={getTableCellStyles('center')}>{index + 1}</TableCell>
                                                        <TableCell sx={getTableCellStyles('center', isHighlightedRow)}>{item.total}</TableCell>
                                                        <TableCell sx={getTableCellStyles('text')}>
                                                            {showCustomerName ? item.CustomerName : ''}
                                                        </TableCell>
                                                        <TableCell sx={getTableCellStyles('text')}>
                                                            {showProductCategory ? item.productCategory : ''}
                                                        </TableCell>
                                                        <TableCell sx={getTableCellStyles('center')}>{item.itemCode}</TableCell>
                                                        <TableCell sx={getTableCellStyles('text')}>{item.item}</TableCell>
                                                        <TableCell sx={getTableCellStyles('text', true)}>{item.kilogram}</TableCell>
                                                        <TableCell sx={getTableCellStyles('center')}>{item.quantity}</TableCell>
                                                        <TableCell sx={getTableCellStyles('center')}>{item.bundle}</TableCell>
                                                        <TableCell sx={getTableCellStyles('center')}>{item.pieces}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{item.totalquantity}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{item.RatePerKg}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{formatDecimal(item.taxableamount)}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{formatDecimal(item.gstamount)}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{formatDecimal(item.totalAmount)}</TableCell>
                                                        <TableCell sx={getTableCellStyles('text')}>
                                                            {showRemarks ? item.Remarks : ''}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={16} sx={getEmptyStateCellStyles()}>
                                                    No data available
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </Modal>


                {/* Extra Loading summary */}
                <Modal open={exshowmodel} onClose={closeexModal}>
                    <div style={getModalWrapperStyles()}>
                        <div style={getModalContentStyles()}>
                            <div style={getButtonContainerStyles()}>
                                <Button
                                    sx={getButtonStyles('excel')}
                                    onClick={handleExtraLoadingExcel}
                                >
                                    Excel
                                </Button>
                                <Button
                                    sx={getButtonStyles('print')}
                                    onClick={handleExtraPrint}
                                >
                                    Print
                                </Button>
                                <Button
                                    sx={getButtonStyles('close')}
                                    onClick={closeexModal}
                                >
                                    Close
                                </Button>
                            </div>

                            <h6 style={getModalTitleStyles()}>Extra Loading Summary</h6>

                            {/* Info Section */}
                            {exFilteredData && exFilteredData.length > 0 && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '12px',
                                    padding: '8px 12px',
                                    backgroundColor: '#f3f3e3',
                                    borderRadius: '6px',
                                    border: '1px solid #ddd'
                                }}>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Route:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {exFilteredData[0]?.routeName || 'N/A'}
                                        </span>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Order Taken by:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {exFilteredData[0]?.orderTakenby || 'N/A'}
                                        </span>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <strong style={{ fontSize: '12px', color: '#2c3e50' }}>Order Date:</strong>
                                        <span style={{ fontSize: '12px', marginLeft: '6px', color: '#2c3e50' }}>
                                            {exFilteredData[0]?.orderDate ? new Date(exFilteredData[0].orderDate).toLocaleDateString('en-GB') : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            )}

                            <TableContainer component={Paper} sx={getTableContainerStyles()}>
                                <Table sx={getTableStyles()}>
                                    <TableHead sx={getTableHeadStyles('extraLoading')}>
                                        <TableRow>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Sl.No</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}> </TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Product Category</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Category</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Code</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Item</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>UOM (Kgs)</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Quantity<br />(no. pieces)</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Bundle</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('center')}>Pieces</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Total Qty<br />(kgs)</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Rate<br />(per Kg)</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Taxable Amt</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Total GST Amt</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('right')}>Total Amt</TableCell>
                                            <TableCell sx={getTableHeaderCellStyles('left')}>Remarks</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {exFilteredData && exFilteredData.length > 0 ? (
                                            exFilteredData.map((item, index) => {
                                                const showRemarks = index === 0 || item.Remarks !== exFilteredData[index - 1].Remarks;
                                                const showProductCategory = index === 0 || item.productCategory !== exFilteredData[index - 1].productCategory;
                                                const showCategory = index === 0 || item.Category !== exFilteredData[index - 1].Category;
                                                const isGrandTotal = item.total === 'GRAND TOTAL';

                                                return (
                                                    <TableRow
                                                        key={item.id}
                                                        sx={getTableRowStyles(isGrandTotal, 'extraLoading')}
                                                    >
                                                        <TableCell sx={getTableCellStyles('center')}>{index + 1}</TableCell>
                                                        <TableCell sx={getTableCellStyles('center', isGrandTotal)}>{item.total}</TableCell>
                                                        <TableCell sx={getTableCellStyles('text')}>
                                                            {showProductCategory ? item.productCategory : ''}
                                                        </TableCell>
                                                        <TableCell sx={getTableCellStyles('text')}>
                                                            {showCategory ? item.Category : ''}
                                                        </TableCell>
                                                        <TableCell sx={getTableCellStyles('center')}>{item.itemCode}</TableCell>
                                                        <TableCell sx={getTableCellStyles('text')}>{item.item}</TableCell>
                                                        <TableCell sx={getTableCellStyles('text', true)}>{item.kilogram}</TableCell>
                                                        <TableCell sx={getTableCellStyles('center')}>{item.quantity}</TableCell>
                                                        <TableCell sx={getTableCellStyles('center')}>{item.bundle}</TableCell>
                                                        <TableCell sx={getTableCellStyles('center')}>{item.pieces}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{item.totalkilogram}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{item.RatePerKg}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{formatDecimal(item.taxableamount)}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{formatDecimal(item.gstamount)}</TableCell>
                                                        <TableCell sx={getTableCellStyles('numeric')}>{formatDecimal(item.totalAmount)}</TableCell>
                                                        <TableCell sx={getTableCellStyles('text')}>
                                                            {showRemarks ? item.Remarks : ''}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={16} sx={getEmptyStateCellStyles()}>
                                                    No data available
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </Modal>
            </div >
        </div >
    );
}

export default TriporderedIndexs;

